// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor3 from '@/game/prefabs/World/Mentors/Mentor3';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level13 extends TilemapScene {
  constructor() {
    super('Level13');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desert_biome_3
    const desert_biome_3 = this.add.tilemap('desert-biome-3');
    desert_biome_3.addTilesetImage('desert sands v01', 'desert sands v01');
    desert_biome_3.addTilesetImage(
      'desert sands prefabs',
      'desert sands prefabs',
    );
    desert_biome_3.addTilesetImage(
      'desert trees 80x112',
      'desert trees 80x112',
    );
    desert_biome_3.addTilesetImage(
      'desert cactuses 32x96',
      'desert cactuses 32x',
    );
    desert_biome_3.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    desert_biome_3.createLayer(
      'terrain',
      ['desert sands v01', 'desert sands prefabs'],
      0,
      0,
    );

    // deco_1
    desert_biome_3.createLayer('deco', ['desert sands v01'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = desert_biome_3.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // tOP_cacti_1
    desert_biome_3.createLayer('TOP cacti', ['desert cactuses 32x96'], 0, 0);

    // player
    const player = new Player(this, 144, 608);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 880, 200);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 544, 592);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 216, 320);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 632, 432);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 832, 304);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 424, 120);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 624, 152);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      152,
      576,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 136, 560, 'desert_trees_sheet', 0);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      120,
      560,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      104,
      544,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      152,
      480,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      712,
      608,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      792,
      576,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      152,
      384,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      312,
      256,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      408,
      272,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      472,
      208,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      552,
      256,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      600,
      288,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      616,
      304,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      648,
      320,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      808,
      304,
      'desert_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      488,
      304,
      'desert_trees_sheet',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      360,
      560,
      'desert_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      632,
      608,
      'desert_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      64,
      240,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      768,
      624,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      176,
      480,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      592,
      304,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 744, 224, 'desert 16x_1', 2);
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 120, 320, 'desert 16x_1', 2);
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 584, 544, 'desert 16x_1', 2);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 696, 272, 'desert 16x', 2);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 248, 112, 'desert 16x', 2);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 104, 288, 'desert 16x', 2);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 104, 304, 'desert 16x', 2);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      368,
      208,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      288,
      256,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      176,
      576,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      736,
      640,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(this, 136, 288, 'desert 16x_1', 1);
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 184, 240, 'desert 16x_1', 1);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 632, 96, 'desert 16x_1', 1);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 648, 112, 'desert 16x_1', 1);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 824, 432, 'desert 16x_1', 1);
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(this, 840, 464, 'desert 16x_1', 1);
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(this, 744, 512, 'desert 16x_1', 1);
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(this, 552, 512, 'desert 16x_1', 1);
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(this, 536, 528, 'desert 16x_1', 1);
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(this, 664, 560, 'desert 16x_1', 1);
    this.add.existing(forestTree_42);

    // mentor
    const mentor = new Mentor3(this, 120, 576);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 848, 176);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 432, 512);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 288, 440);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 264, 160);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 12;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 12;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 12;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 12;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 12;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 12;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 12;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 12;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 12;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 12;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.desert_biome_3 = desert_biome_3;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor3;
  private desert_biome_3!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.desert_biome_3,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
